import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const PartsInventoryAdjustment = {
	name: NAME,
	apiProvider,
	router,
};
